import { useState, useEffect, useRef } from "react";
import Hero from "./Hero/Hero";
import FilterByBrand from "./Fitler/FilterByBrand";
import FilterBySegment from "./Fitler/FilterBySegment";
import ProductsLanding from "./Landing/ProductsLanding";
import Container from "Components/Container/Container";
import Spinner from "Components/RequestHandler/Spinner";
import { useParams, useLocation } from "react-router-dom";
import useFetch from "Hooks/useFetch.js";
import { X } from "@phosphor-icons/react";

const Products = () => {
  const { slug } = useParams();
  const { state } = useLocation();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { fetchData } = useFetch();
  const [selectedFilter, setSelectedFilter] = useState(
    localStorage.getItem("selectedFilter") || ""
  ); // Retrieve from localStorage
  const [isBrandFilter, setIsBrandFilter] = useState(false);
  const [activeFilter, setActiveFilter] = useState();

  const handleSelectedFilter = (filter) => {
    setSelectedFilter(filter);
    localStorage.setItem("selectedFilter", filter); // Save to localStorage when filter is updated
  };

  const handleActiveFilter = (activeFilter) => {
    setActiveFilter(activeFilter);
  };

  const getData = async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      const data = await fetchData(`products-by-segment/${slug}`);
      setData(data);
      setIsBrandFilter(false);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const getDataByBrand = async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      const data = await fetchData(`products-by-brand/${slug}`);
      setData(data);
      setIsBrandFilter(true);
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // Handle initial data fetching based on stored or current selectedFilter
    if (selectedFilter === "brand" || (state && state?.isBrand)) {
      getDataByBrand();
      handleActiveFilter(slug);
    } else if (selectedFilter === "segment") {
      getData();
      handleActiveFilter(slug);
    } else if (!selectedFilter) {
      getDataByBrand();
      handleActiveFilter("martin");
    }
  }, [slug, selectedFilter]);

  // Filter UI for both mobile and desktop
  const [filterIsVisible, setFilterIsVisible] = useState(false);
  const handleFilterVisible = () => {
    setFilterIsVisible((cur) => !cur);
  };

  const containerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      setIsScrollable(container.scrollHeight > container.clientHeight);
    }
  }, [data]);

  return (
    <main>
      <Hero background={data?.brand_background} />
      <Container>
        <div className="flex gap-x-24 scroll-section-special mb-primary relative z-[1000] ">
          <div className={`flex-1 hidden xl:flex flex-col gap-y-14`}>
            <div
              ref={containerRef}
              className={`sticky top-[10vh] pb-[14vh] max-h-[100vh] z-[100] pr-6 custom-scrollbar  ${
                isScrollable ? "overflow-y-scroll" : "overflow-y-hidden"
              }`}
            >
              <FilterByBrand
                onHandleActiveFiler={handleActiveFilter}
                activeFilter={activeFilter}
                data={data?.brands}
                onHandleFilter={(filter) => handleSelectedFilter("brand")}
              />
              <FilterBySegment
                selectedFilter={selectedFilter}
                onHandleFilter={(filter) => handleSelectedFilter("segment")}
                data={data?.segment_category}
                onHandleActiveFiler={handleActiveFilter}
                activeFilter={activeFilter}
              />
            </div>
          </div>

          <div
            className={`flex flex-col xl:hidden transition ease-in duration-500 top-1/2 -translate-y-1/2  ${
              filterIsVisible
                ? "fixed bg-black z-[100000000000] border border-[#aaa] w-[90vw] h-[90vh] overflow-y-scroll px-4 py-8   left-1/2 -translate-x-1/2 opacity-100 visible select-auto"
                : "absolute  translate-x-[-200%] opacity-0 invisible select-none"
            }`}
          >
            <button
              onClick={handleFilterVisible}
              className="text-white mb-4 w-max flex items-end justify-end ml-auto"
            >
              <X size={28} />
            </button>

            <FilterByBrand
              onHandleFiler={handleFilterVisible}
              onHandleActiveFiler={handleActiveFilter}
              activeFilter={activeFilter}
              data={data?.brands}
              onHandleFilter={(filter) => handleSelectedFilter("brand")}
            />
            <FilterBySegment
              onHandleFiler={handleFilterVisible}
              selectedFilter={selectedFilter}
              onHandleFilter={(filter) => handleSelectedFilter("segment")}
              data={data?.segment_category}
              onHandleActiveFiler={handleActiveFilter}
              activeFilter={activeFilter}
            />
          </div>
          {isLoading ? (
            <div className="flex-[3] flex flex-col items-center mt-10">
              <Spinner />
              <p className="text-white mt-2">Loading Products...</p>
            </div>
          ) : (
            <ProductsLanding
              onHandleFiler={handleFilterVisible}
              catName={data?.segment_name}
              data={data}
              isBrandFilter={isBrandFilter}
            />
          )}
        </div>
      </Container>
    </main>
  );
};

export default Products;
